<template>
  <nav class="home-navbar center-align"
    v-bind:class="{ floating: floating }"
  >
    <button class="search-icon flat-button js-newpage" @click.prevent="navigatorPush('Search')">
      <icon-search />
    </button>
    <ul class="no-bullet ph-nav" v-if="loading">
      <li><a href="#new" class="ph-text">■■■</a></li>
      <li><a href="#unfinished" class="ph-text">■■■■■■</a></li>
      <!-- <li><a href="#hot" class="ph-text">■■■</a></li> -->
      <li><a href="#recommended" class="ph-text">■■■■■■■■■■■</a></li>
      <!-- <li><a href="#editors-pick" class="ph-text">■■■■■■■■■■■■■</a></li> -->
      <li v-for="i in [1,2,3]"><a href="" @click.prevent="" class="ph-text">{{ '■'.repeat(4+((4-i)%3)) }}</a></li>
    </ul>
    <ul class="no-bullet" v-else>
      <li><a href="#new">{{ $t("home.nav.new") }}</a></li>
      <li><a href="#unfinished">{{ $t("home.nav.unfinished") }}</a></li>
      <!-- <li><a href="#hot">Hot</a></li> -->
      <li><a href="#recommended">{{ $t("home.nav.recommended") }}</a></li>
      <!-- <li><a href="#editors-pick">Editor&#39;s pick</a></li> -->
      <li
        v-for="tag in featuredTags || []"
        :key="tag.id"
      >
        <a :href="'#featured-tag-'+tag.id">{{ tag.display_title || tag.name }}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: ['floating', 'loading', 'featuredTags'],
};
</script>
